// Extraído de EditarFechaCobroModal (función `persistir`) — Fase 1 de "Futuros: reagendar"
// (2026-09-23). Mismo comportamiento exacto: se movió el cuerpo de la función a un util standalone
// para que el modal Y el despachador nuevo `reagendarEntryFuturo` llamen a LA MISMA función (10.1).
//
// Override manual de la fecha de cobro estimada de una entry del Backlog (pipeline). Soporta tres
// orígenes:
//   - "sales": columna directa sales.fecha_cobro_estimada (por id).
//   - "contratos": key dentro del objeto de cuota en el JSONB sales_contratos.meses[cuota_index].
//   - "carteleria" HARDWARE (tramo del split, con `linea_id`): L6 tramo 3 — escribe por
//     `actualizar_linea_facturacion(linea_id, {fecha_cobro_estimada})`, que ubica el elemento por
//     CLAVE NATURAL en el servidor (nunca por posición). CAJA PURA: la RPC solo mergea esa key; no
//     toca facturafecha/facturanumero/plazocobro/monto/porcentaje ni el resto del array. Sin
//     `linea_id` (tramo sin fecha propia → sin línea derivada) no se puede editar — error visible
//     (10.177), nunca un fallback al índice posicional del array. La cuota de GESTIÓN de cartelería
//     (sin linea_id) NO se edita por acá.
//
// `nuevaFecha` puede ser `null` (volver a la fecha automática, "Restaurar"; solo lo usa el modal
// viejo) o "YYYY-MM-DD".
import { client } from "./supabase";

export const guardarFechaCobroPipeline = async ({ f, nuevaFecha, userId }) => {
  if (f.origen === "carteleria") {
    if (f.linea_id == null) {
      // 10.177: sin línea (tramo sin fecha propia) no hay dónde escribir el override — visible,
      // no fallback a posición.
      throw new Error("Este tramo de hardware no tiene línea de facturación — no se puede editar el cobro estimado.");
    }
    const { error } = await client.rpc("actualizar_linea_facturacion", {
      p_linea_id: f.linea_id,
      p_campos: { fecha_cobro_estimada: nuevaFecha },
      p_usuario_id: parseInt(userId, 10) || null,
    });
    if (error) throw error;
    return;
  }
  if (f.origen === "sales") {
    const { error } = await client.from("sales").update({ fecha_cobro_estimada: nuevaFecha }).eq("id", f.sale_id);
    if (error) throw error;
    return;
  }
  if (f.origen === "contratos") {
    const { data, error: errLeer } = await client
      .from("sales_contratos")
      .select("meses")
      .eq("id", f.contrato_id)
      .single();
    if (errLeer) throw errLeer;
    const mesesActualizado = [...(data?.meses || [])];
    // 10.177: un `cuota_index` inválido (no entero, negativo, o fuera del array) NUNCA debe llegar al
    // UPDATE de abajo — sin este guard, `mesesActualizado[f.cuota_index] = cuota` escribe en un índice
    // que no existe (agranda el array con huecos) o pisa `undefined`/una posición fuera de rango: el
    // UPDATE "sale bien" (sin error de Postgres) pero no cambia el dato que se pretendía cambiar — un
    // fallo silencioso clásico. Falla ANTES de armar el UPDATE, con mensaje explícito.
    if (!Number.isInteger(f.cuota_index) || f.cuota_index < 0 || f.cuota_index >= mesesActualizado.length) {
      throw new Error(
        `cuota_index inválido (${JSON.stringify(f.cuota_index)}) para el contrato ${f.contrato_id} — ` +
          `debe ser un entero entre 0 y ${mesesActualizado.length - 1}.`
      );
    }
    const cuota = { ...mesesActualizado[f.cuota_index] };
    if (nuevaFecha) {
      cuota.fecha_cobro_estimada = nuevaFecha;
    } else {
      delete cuota.fecha_cobro_estimada;
    }
    mesesActualizado[f.cuota_index] = cuota;
    const { error } = await client.from("sales_contratos").update({ meses: mesesActualizado }).eq("id", f.contrato_id);
    if (error) throw error;
    return;
  }
  throw new Error(`Origen no soportado: ${f.origen}`);
};
